/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomSysOrganizationsParentCompanyLocationSelect/view.blocks to change it.
import Location from './Location/index'
import ParentCompany from './ParentCompany/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomSysOrganizationsParentCompanyLocationSelect({
  children,
  viewPath = "/DesignSystem/DataVaxiomSysOrganizationsParentCompanyLocationSelect",
  marginTop = 0,
  marginLeft = 0,
  allowEmptyChoiceLocation
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DataVaxiomSysOrganizationsParentCompanyLocationSelect.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Hsbm5': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-2-Hsbm5': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Horizontal}`}
>
<ParentCompany
  viewPath={`${viewPath}/ParentCompany`}
/>
<Location
  viewPath={`${viewPath}/Location`}
 allowEmptyChoice={allowEmptyChoiceLocation}
/>
</div>
{children}
</React.Fragment>)
}